import { ReactNode } from "react";
import { Crown, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface Props {
  premium: boolean;
  canBuy: boolean;
  guildId: string;
  featureName: string;
  children: ReactNode;
}

export function PremiumGate({
  premium,
  canBuy,
  guildId,
  featureName,
  children,
}: Props) {
  const navigate = useNavigate();
  if (premium) return <>{children}</>;

  return (
    <div className="relative">
      <div className="pointer-events-none opacity-30 blur-[2px]">
        {children}
      </div>
      <div className="absolute inset-0 z-10 flex items-center justify-center bg-background/50 backdrop-blur-sm rounded-xl">
        <div className="max-w-md text-center p-8 rounded-xl border border-amber-500/30 bg-gradient-to-br from-amber-500/10 to-orange-500/5">
          <div className="h-14 w-14 rounded-full mx-auto mb-4 flex items-center justify-center bg-gradient-to-br from-amber-400 to-orange-500 shadow-lg shadow-amber-500/30">
            <Crown className="h-7 w-7 text-zinc-900" />
          </div>
          <h3 className="text-xl font-bold mb-1">{featureName} is Premium</h3>
          <p className="text-sm text-muted-foreground mb-3">
            This web panel module is only available on the <strong>Premium</strong> plan.
          </p>
          <p className="text-xs text-muted-foreground mb-5 max-w-sm mx-auto">
            <strong>Games &amp; economy</strong> in the sidebar works without Premium (amber &quot;Free&quot; badge).
          </p>
          {canBuy ? (
            <Button
              variant="premium"
              onClick={() => navigate(`/premium/${guildId}`)}
            >
              <Crown className="h-4 w-4" />
              Get Premium
            </Button>
          ) : (
            <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground">
              <Lock className="h-4 w-4" />
              Only the server owner can enable Premium.
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
